import { ClientPostTypeEnum } from '@DigitaleDoerfer/digitale-doerfer-api';

import type { PostFormValues } from '@/features/post-editor/types/postForm';
import { DorfHelferTypeEnum } from '@/features/posts/types/dorfHelferType';
import { PostFeedType } from '@/features/posts/types/postFeed';
import { TODAY } from '@/time';

export const MINISTRY_GEO_AREA_DEPTH = 1;

export const EMPTY_POST_FORM: PostFormValues = {
  channelType: PostFeedType.GOSSIP,
  marketType: ClientPostTypeEnum.Offer,
  dorfHelferType: DorfHelferTypeEnum.OFFER,
  title: '',
  text: '',
  allDay: true,
  startDate: TODAY,
  endDate: undefined,
  location: undefined,
  suggestionCategory: undefined,
  poll: undefined,
  hiddenForOtherHomeAreas: false
};
